import { useContext, useEffect, useState } from 'react';
import { UserContext, swrFetcher } from 'contexts/user/index';
import { MemberResponse } from 'lib/teams';
import useSWR from 'swr';

const usePermission = (teamId?: number, memberId?: number) => {
  const { user } = useContext(UserContext);
  const [isMe, setMe] = useState<boolean>(false);
  const [isOwner, setOwner] = useState<boolean>(false);
  const [isAdmin, setAdmin] = useState<boolean>(false);
  const [isMember, setMemeber] = useState<boolean>(false);
  const [hasLoaded, setLoaded] = useState<boolean>(false);

  const { data: members } = useSWR<MemberResponse[]>(
    teamId ? `/api/teams/${teamId}/affiliates` : null,
    swrFetcher
  );

  useEffect(() => {
    const self = members?.find(
      (m) => m.ownerId === (memberId ?? user?.ownerId)
    );
    if (self) {
      setMe(user?.ownerId === memberId);
      setOwner(self.permission === 'Owner');
      setAdmin(['Owner', 'Admin'].includes(self.permission));
      setMemeber(self.permission === 'Member');
      setLoaded(true);
    }
  }, [user, members]);

  return { isMe, isOwner, isAdmin, isMember, hasLoaded };
};

export default usePermission;
